exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-form .el-form-item[data-v-4a79be80]{margin-bottom:0}.box-card[data-v-4a79be80]{width:100%}.clearfix[data-v-4a79be80]:before,.clearfix[data-v-4a79be80]:after{display:table;content:\"\"}", ""]);

// exports
